import { useCallback, useState } from 'react';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { ApiError, UnknownError } from '@packages/shared/core/common/errors';
import { useServices } from './useServices';
import { useLogger } from './useLogger';

export function useUpdateEmailConsent() {
  const [status, setStatus] = useState(LoadingStatuses.IDLE);

  const logger = useLogger();

  const { userService, analyticsService } = useServices();

  const fetchUpdateEmailConsent = useCallback(
    async (emailConsent: boolean) => {
      setStatus(LoadingStatuses.PENDING);
      try {
        await userService.setEmailConsent(emailConsent);
        await analyticsService.setEmailConsent(emailConsent);
        setStatus(LoadingStatuses.FULFILLED);
      } catch (err) {
        const error = err instanceof ApiError ? err : new UnknownError(err);
        logger.error(error);
        setStatus(LoadingStatuses.FAILED);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userService, logger],
  );

  return {
    fetchUpdateEmailConsent,
    status,
  };
}
